import api from "../axiosInstance";

export const getMerchandiseRequest = async (payload) => {
  try {
    const response = await api.get(
      `/merchandiseProduct/request?${
        payload.status || payload.status === 0 ? `status=${payload.status}` : ""
      }&${payload.page ? `page=${payload.page}` : ""}&${
        payload.limit ? `limit=${payload.limit}` : ""
      }`
    );
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const editMerchandiseRequestStatus = async (payload) => {
  try {
    const response = await api.put(
      `/merchandiseProduct/request?${payload._id ? `id=${payload._id}` : ""}&${
        payload.status === 0 || payload.status ? `status=${payload.status}` : ""
      }&${
        payload.productLink
          ? `productLink=${encodeURIComponent(payload.productLink)}`
          : ""
      }&${payload.description ? `description=${payload.description}` : ""}`
    );
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const editMerchandiseRequestDetails = async (id, payload) => {
  try {
    const response = await api.patch(
      `/merchandiseProduct/request/edit?id=${id}`,
      payload
    );
    return response.data.data;
  } catch (err) {
    throw err;
  }
};
